import { Controller } from "@hotwired/stimulus"
import axios from 'axios'

export default class extends Controller {
  send({ params: { path, itemId } }) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken
    axios.post('/events/clicks', {
      path: path,
      item_id: itemId
    })
  }
}
